export interface WhatsAppSender {
  id: number
  number: string
  waba_id: string | null
  meta_phone_number_id: string | null
  twilio_subaccount_sid: string | null
  messaging_service_sid: string | null
  twilio_sender_sid: string | null
  whatsapp_status: string | null
  assistant_id: number | null
  created_at: string
}

export const whatsappConnectionKeys = {
  all: ['messaging-whatsapp-connections'] as const,
}
